<template>
  <div class="code-page">
    <div class="main-container container-flex">
      <div class="col-one-code col50">
       
        <p>El éxito es la suma de pequeños esfuerzos día a día.</p>
        <hr>
      </div>
      <div class="col-two col50">
        <div class="col-logo">
          <img src="../assets/logo.jpg">
        </div>
        <div class="form-container-code">
          <h5 >Ingresa el código que fue enviado a tu correo electrónico</h5>
          <form @submit.prevent="verify(code_form)" id="logincodeapp"  >  
            <div class="row-block">
              <input 
                  id="code" 
                  v-model="code_form" 
                  type="text" 
                  name="code" 
                  required
                  placeholder="35D2N9"
              >
            </div>
            <p v-if="status=='error'" class="error-code">El codigo no coincide.</p>
            <div class="btn-code dflxca">
               <button  type="submit" class="verf" > Verificar</button>
            </div >
            <div  class="form-solicitar-codigo dflxca"> 
                 <p class="form-reenviar-codigo " @click="sendCode()">¿Problemas? <u> Solicita un nuevo código aquí</u> </p>
            </div>
          </form>
        </div>
       
      </div>
    </div>
  </div>
</template>
<script>


import userService from '../services/user.service'

export default {
  name: 'autentificacion',
  data: () => ({
    code_form: "",
    status:'',
  }),
  computed:{
    token() {
      return this.$store.getters['userService/getToken'];
    },
    identity() {
      return this.$store.getters['userService/getIdentity'];
    }
  },
  methods: {
      verify: async function(code_form){
          let token = userService.getToken();
          let identity = userService.decode(token);
        
          if(code_form == identity.code ){
             let ath = await userService.createAuth();
             await userService.setAth(ath);
             this.$router.push("/").catch(err => {});
             
          }else{
            this.status='error' 
          } 
      },
      
      mostrarCodigo(){
          //de momento para facilitar las pruebas mostrar el codigo en un alert.
          let token = userService.getToken();
          let identity = userService.decode(token);
          alert(identity.code);
      },

     
      async sendCode() {
      try {
         let token = userService.getToken();
         let identity = userService.decode(token);

        await this.$store.dispatch("userService/resendCode", {
            email: identity.email,
            name: identity.name,
            code: identity.code
        });
        //console.log(identity.code);
       
      } catch (error) {
        this.status ='error'
      }
    }
  }
}
</script>


